@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.active-checkmark {
  color: @product-page--grid-row-checkmark--active--icon-color;
  width: 20px;
  height: 16px;
}

.tooltip-text {
  max-width: 300px;
}

.right-align-column {
  text-align: right;
}

.header {
  display: flex;
  gap: 8px;
  align-items: center;
}

.icon {
  height: 16px;
  vertical-align: middle;
  color: @product-page--grid-row-icon--fill-color;
}

.image {
  max-height: 30px;
  width: 100%;
  margin: 0;
}
